import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function HScroll({ children, testId = "hscroll" }) {
  const ref = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const update = () => {
    const el = ref.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 4);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [children]);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  };

  const arrowClass =
    "absolute top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white/95 border border-[#E5E0D8] shadow-md flex items-center justify-center hover:bg-[#F9F6F0] transition-colors";

  return (
    <div className="relative" data-testid={testId}>
      {canLeft && (
        <button onClick={() => scrollBy(-1)} className={`${arrowClass} -left-2`} aria-label="Scroll left" data-testid={`${testId}-left`}>
          <ChevronLeft className="w-5 h-5 text-[#3A5A40]" />
        </button>
      )}
      <div ref={ref} className="flex gap-3 overflow-x-auto scroll-smooth snap-x pb-1 hide-scrollbar">
        {children}
      </div>
      {canRight && (
        <button onClick={() => scrollBy(1)} className={`${arrowClass} -right-2`} aria-label="Scroll right" data-testid={`${testId}-right`}>
          <ChevronRight className="w-5 h-5 text-[#3A5A40]" />
        </button>
      )}
    </div>
  );
}
